module.exports = __webpack_public_path__ + "img/architecture5.281aaf37.webp";